import React from 'react';

import { StreamSearchContextValueType } from './StreamSearchContextValueType';

export const StreamSearchContext = React.createContext<StreamSearchContextValueType>(
  {} as StreamSearchContextValueType
);
